/**
 * Indicator 스타일
 * @description 컴포넌트 토큰이 없어 시맨틱으로 조립한다. 색은 디자이너가 `border.*` 로
 *   잡아둔 그대로다 — 채움인데 이름이 border 인 건 어색하지만 이 알파값의 시맨틱 이름이
 *   거기뿐이다. 활성 점만 폭이 넓어지고 높이는 같다.
 */

/** 점 지름 8 — `size.control`(24~) 과 `size.icon`(12~) 어디에도 없다. 스케일이 늘면 교체 */
export const INDICATOR_DOT_SIZE = "8px";

export const indicatorStyles = {
  root: "flex items-center justify-center gap-[var(--fw-space-gap-xs)]",
  dot: "rounded-[var(--fw-radius-full)] bg-[var(--fw-color-border-disabled)] transition-all",
  dotActive: "w-[var(--fw-size-control-xs)] bg-[var(--fw-color-border-strong)]",
};
